<script>
    export let employee;

    import { sendNotification } from "../http.js";
</script>

<input type="submit" class="button is-info has-text-weight-bold my-2" on:click="{sendNotification(employee)}"
        name="notification" id="notification" value="Powiadom">